export default __webpack_public_path__ + "static/media/airbnb.44b40aef.png";